import React, { useMemo, useState, useEffect, useRef } from 'react';
import { REALTIME_TARGETS, OFFLINE_TARGETS } from './constant';
import apis from '@/pages/mvp-panel/participant-data/apis';
import { message } from '@drip/drip-design';
// @ts-ignore
import { CheckboxGroup, Annotation, Icon, Collapse} from '@jd/jmtd';
// @ts-ignore
import { search } from '@jd/jmtd-tools/es/tree';
// @ts-ignore
import classNames from '@jd/jmtd-tools/es/classnames';
import _, { isString } from 'lodash';

function TargetSelect(props: any) {
  const { dataType, onChange, itemType } = props;
  const _onChange = useRef(onChange);
  // 用户已保存的指标
  const [indicators, setIndicators] = useState<any[] | [] | null>(null);
  //当前选中的指标
  const [currentIndicators, setCurrentIndicators] = useState<any[] | [] | null>(null);

  const [closedMap, setClosedMap] = useState({});

  const [searchValue2, setSearchValue2] = useState('');
  const targetSource = useMemo(() => {
    let result = [];
    if (dataType === 'REALTIME') {
      return (result = _.cloneDeep(REALTIME_TARGETS));
    }
    if (itemType == '2') {
      return (result = OFFLINE_TARGETS.filter((item) => item.label != '排名指标' && item.label != '服务指标'));
    }
    return (result = _.cloneDeep(OFFLINE_TARGETS));
  }, [dataType, itemType]);

  const [handleData, setHandleData] = useState(targetSource);

  const getItemLength = (arr: Array<any>) => {
    let length = 0;
    arr.map((item) => {
      length = length + item.data.length;
    });
    return length;
  };

  const saveTargets = (v: any) => {
    apis
      .saveGoodsAnalysisIndexInfo({ indicators: currentIndicators, dataType })
      .then((res) => {
        const { msg, ret } = res;
        if (ret !== '0') throw msg || '保存失败';
        setIndicators(currentIndicators);
        message.success('保存成功');
      })
      .catch((ex) => {
        message.error(ex);
      });
  };
  useEffect(() => {
    apis
      .queryGoodsAnalysisIndexInfo({ dataType })
      .then((res) => {
        const { msg, ret, data } = res;
        if (ret !== '0' || !data.indexNames) {
          setIndicators([]);
          setCurrentIndicators([]);
          throw msg || '指标请求失败';
        }
        setIndicators(data.indexNames);
        setCurrentIndicators(data.indexNames);
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [dataType, itemType]);
  useEffect(() => {
    if (!currentIndicators) return;
    //@ts-ignore
    // _onChange.current(currentIndicators.concat(['ge_deal_standard_deal_ord_amt']));
    _onChange.current(currentIndicators);
  }, [currentIndicators]);

  useEffect(() => {
    setSearchValue2('');
    setHandleData(targetSource);
  }, [targetSource]);


  return indicators ? (
    <div className="target-select-block">
      <div className="target-select-title-block">
        <span>
          <span className="target-set-title"
                onClick={()=>{setClosedMap(!closedMap)}}
          >
            <Icon
              size={14}
              className={classNames({
                'jmt-caret-right': closedMap,
                'jmt-caret-up': !closedMap
              })}
            />
            选择指标
          </span>（已选<a>{currentIndicators?.length}</a>/
          {getItemLength(targetSource)}）:
        </span>
      </div>
      <Collapse open={!closedMap}>
        <CheckboxGroup
          separator
          value={currentIndicators ?? []}
          showLength
          showAll
          showReset
          showClear
          showSearch
          searchValue={searchValue2}
          onSearch={(v: any) => {
            if (v) {
              let searchData = search(
                handleData,
                (item: any) => {
                  if (isString(item?.label)) {
                    return item?.label?.includes(v);
                  }
                  return item?.label?.props?.children?.[0]?.includes(v);
                },
                {
                  childrenName: 'data',
                }
              )
              searchData = searchData.map((item:any)=>({...item,showMore:true}))
              setHandleData(searchData)
            } else {
              setHandleData(targetSource);
            }
            setSearchValue2(v);
          }}
          data={handleData}
          onChange={setCurrentIndicators}
          resetValue={indicators}
          showSave
          onSave={(v: any) => {
            saveTargets(v);
            if(!_.isEmpty(document.getElementById('participant-title-con'))){
              const btn = document.getElementById('participant-title-con')
              btn?.setAttribute("clsTag", 'h|keycount|x_center_hzcp_1678258944439|18');
              // @ts-ignore
              btn.addEventListener('click', ()=>{console.log('触发yx_center_hzcp_1678258944439|18')});
              // @ts-ignore
              btn.click();
              // @ts-ignore
              btn.removeEventListener('click', ()=>{}, false)
              btn?.setAttribute("clsTag", '');
              btn?.removeAttribute("clsTag")
            }
          }}
          onCollapse={(index: any, d: any) => {
            const newD = [...d];
            // @ts-ignore
            handleData[index].showMore = !newD[index].showMore;
            setHandleData([...handleData]);
          }}
          onClear={() => {
            setCurrentIndicators(['ge_deal_standard_deal_ord_amt']);
          }}
        />
      </Collapse>
    </div>
  ) : null;
}
export default TargetSelect;
